import React, { useState, useEffect } from 'react'
import './Note.css'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { FaEdit } from 'react-icons/fa'
import { formatDate } from './helpers/formatDate'
import { noteTypes } from '../assets/data/data'

function Note({ type, note, date, subject, setSelectedNote, noteObj, popupWindowID, setPopupActive, onDelete, onEdit }) {
  const [picto, setPicto] = useState(null)

  useEffect(() => {
    const defaultPicto = noteTypes['Note'].picto // Default to 'Note' picto if the type is not found
    setPicto(noteTypes[type]?.picto || defaultPicto)
  }, [type])

  const handleOnClickNote = () => {
    setPopupActive(true)
    setSelectedNote(noteObj)
  }

  const handleDelete = (e) => {
    e.stopPropagation()
    if (typeof onDelete === 'function') {
      onDelete(noteObj)
    }
  }

  const handleEdit = (e) => {
    e.stopPropagation()
    if (typeof onEdit === 'function') {
      onEdit(noteObj)
    }
  }

  return (
    <div className='note__container' onClick={handleOnClickNote}>
      <div className='note_icon'><img src={picto} /></div>
      <div className='note_body'>
        <div className='note_top_row'>
          <div className='note_text'>{subject || 'No subject'}</div>
          <div className='note_type'>{type || 'Note'}</div>
        </div>
        <div className='date_note'>{formatDate(date)}</div>
      </div>
      {onEdit && (
        <button className='note_action_button note_edit_button' type='button' onClick={handleEdit} title='Edit note'>
          <FaEdit />
        </button>
      )}
      {onDelete && (
        <button className='note_action_button note_delete_button' type='button' onClick={handleDelete} title='Delete note'>
          <DeleteOutlineIcon />
        </button>
      )}
    </div>
  )
}

export default Note 
